import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import AuthService from './authService';

class ChatBotService {
	authService = new AuthService();
	// constructor() {
	// 	axios.defaults.baseURL = `${Constants.apiUrl}/`;
	// 	axios.defaults.headers = {
	// 		"Content-Type": "application/json; charset=utf-8",
	// 		Pragma: 'no-cache'
	// 	}
	// }

	getChatToken() {
		return axios({
			url: `${Constants.chatApiUrl}/token`,
			method: 'get',
			headers: {
				Authorization: `Bearer ${this.authService.getToken()}`,
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache'
			},
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

}

export default ChatBotService;
